import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import { ChevronRight } from '../../Icons';


interface StepConfig {
  title: string
}

interface StepProps {
  isActive: boolean,
  isShouldShowSeparator: boolean,
  isAvailableToClick: boolean,
  onClick: () => void,
  stepConfig: StepConfig
}

function Step({
                isActive,
                isShouldShowSeparator,
                isAvailableToClick,
                onClick,
                stepConfig: {title}
              }: StepProps) {

  const color = isActive ? '#BF295C' : '#828282';

  const titleStyle = useMemo(() => {

    let style = {
      color,
      fontSize: '18px',
      fontWeight: '500',
      cursor: 'default',
    };

    if (!isActive) {
      style = {
        ...style,
        ...{
          fontWeight: '400',
        }
      };

      if (isAvailableToClick) {
        style = {
          ...style,
          ...{
            textUnderlineOffset: '4px',
            '&:hover': {
              cursor: 'pointer',
              textDecoration: 'underline',
            }
          }
        }
      }
    }

    return style;

  }, [isActive]);

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
    }}>
      <Typography sx={titleStyle} onClick={onClick}>
        {title}
      </Typography>
      {
        isShouldShowSeparator ? (<ChevronRight sx={{
          margin: '0 16px',
          fontSize: '16px',
          color
        }}/>) : null
      }
    </Box>
  );
}


interface StepplerProps {
  steps: Array<StepConfig>,
  maxAvailableStepToClick: number,
  activeStep: number,
  onStepChange: (nextStep: number) => void,
}

export function Steppler({
                           steps,
                           maxAvailableStepToClick,
                           activeStep,
                           onStepChange,
                         }: StepplerProps) {
  return (
    <Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        justifyContent: 'center',
      }}>
        {steps.map((step, i) => {
          return (
            <Step
              key={step.title}
              stepConfig={step}
              isAvailableToClick={i <= maxAvailableStepToClick}
              isActive={i === activeStep}
              isShouldShowSeparator={i !== steps.length - 1}
              onClick={() => {
                i !== activeStep && i <= maxAvailableStepToClick && onStepChange(i)
              }} />
          )
        })}
      </Box>
    </Box>
  );
}
